import BaseService from '@/services/BaseService';

class MaxPriceService extends BaseService {
    getMaxPrice = (filters) => this.post('/agency/maxprice', filters || { });
}

export default new MaxPriceService();
